import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-714d9fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-comment-main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-status-icon" }, null, -1))
const _hoisted_3 = { class: "m-comment" }
const _hoisted_4 = { class: "u-comment-title" }
const _hoisted_5 = { class: "u-status-text" }
const _hoisted_6 = { class: "u-comment-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-comment-wrap", {'u-pass': $props.progress === 3}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode("老师批改意见 "),
          _createElementVNode("span", _hoisted_5, _toDisplayString($props.progress === 3 ? '通过' : '未通过'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.commentInfo.comment || $setup.defaultText[$props.progress === 3 ? 'pass' : 'unpass']), 1)
      ])
    ])
  ], 2))
}